<template>
  <ul class="radio-button-navigation">
    <li
      v-for="{ name, url } in links"
      :key="name"
      class="radio-button-navigation-item"
      :class="{ active: isLinkActive(url) }"
    >
      <a
        :href="url"
        class="radio-button-navigation-link"
        :class="{ active: isLinkActive(url) }"
        @click="onClick"
      >
        {{ name }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'RadioButtonNavigation',
  props: {
    links: { type: Array, required: true },
  },
  data() {
    return { currentUrl: location.href }
  },
  methods: {
    /**
     * Returns true if we're currently on the given link location
     * @param {string} url
     * @return {boolean}
     */
    isLinkActive(url) {
      return this.currentUrl === url
    },

    /**
     * Prevents clicks from reloading the browser if they're pointing at the current site.
     * @param {Event} event
     */
    onClick(event) {
      if (event.target.href === location.href) {
        event.preventDefault()
      }
    },

    /**
     * Updates the current URL when the location changes.
     */
    onLocationChange() {
      this.currentUrl = location.href
    },
  },
  watch: {
    $route() {
      this.onLocationChange()
    },
  },
  mounted() {
    window.addEventListener('popstate', this.onLocationChange)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onLocationChange)
  },
}
</script>

<style lang="scss" scoped>
.radio-button-navigation {
  --border-width: 2px;

  display: inline-flex;
  padding-left: 0;
  list-style: none;
  color: $grayLight;
}

.radio-button-navigation-item {
  // Override global Fessor style start
  background: none;
  padding-left: 0;
  line-height: 1.2em;
  // Override global Fessor style end

  &:not(:first-child) {
    margin-left: calc(0px - var(--border-width));
  }

  &.active {
    color: $blueDark;
    z-index: 1;

    > .radio-button-navigation-link {
      background: $infoBackground;
    }
  }

  &:first-child > .radio-button-navigation-link {
    border-radius: $borderRadiusLarge 0 0 $borderRadiusLarge;
    padding-left: 1.2em;
  }
  &:last-child > .radio-button-navigation-link {
    border-radius: 0 $borderRadiusLarge $borderRadiusLarge 0;
    padding-right: 1.2em;
  }
}
.radio-button-navigation-link {
  display: block;
  padding: 0.4em 0.8em;
  background: $white;
  border: var(--border-width) solid currentColor;
  text-decoration: none;
  text-transform: uppercase;
  color: inherit;

  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
